import { useTranslate } from '@tolgee/react';
import { useRequest } from 'ahooks';
import { Button, Switch } from 'antd';
import DecorateTitle from 'components/DecorateTitle';
import { useState } from 'react';
import { requestDownloadPathCache } from 'services/cache';
import chatttSDK from 'services/chattt';

export const DownloadPath = () => {
  const { t } = useTranslate();
  const { data: downloadPath, refresh: refreshDownloadPath } = useRequest(
    async () => await chatttSDK?.app.getDownloadPath(false),
  );
  const [requestDownloadPath, setRequestDownloadPath] = useState(
    Boolean(requestDownloadPathCache.get()),
  );
  return (
    <>
      <DecorateTitle>{t('system_setting_save_file')}</DecorateTitle>
      <div className="">
        <span>{downloadPath}</span>
        <Button
          className="mr-4"
          type="link"
          onClick={() => chatttSDK?.app.updateDownloadPath().then(() => refreshDownloadPath())}
        >
          {t('system_setting_select_dir')}
        </Button>
      </div>
      <div className="flex gap-2 mb-4">
        <span>{t('download_path_request_for_every_file')}</span>
        <Switch
          checked={requestDownloadPath}
          onChange={(checked) => {
            setRequestDownloadPath(checked);
            requestDownloadPathCache.set(checked);
          }}
        />
      </div>
    </>
  );
};
